export const bookNav = [{
  id: 1,
  name: '语文教材',
  icon: 'yuwenjiaocai',
  pathName: 'book_ware'
}, {
  id: 2,
  name: '诵读资源',
  icon: 'ziyuan',
  pathName: 'book_library'
}]
